import React from "react";

import Link from "./base/link";

import { useContentContext } from "../context/content-context";

const NavigationLink = ({ to, children, variant }) => {
  const { isHCP } = useContentContext();
  const getsSpecialMargin =
    variant === "footer" && children === "Furoscix for CKD";

  const VARIANT_STYLES = {
    footer: {
      variant: isHCP ? "navigationBlue" : "navigationWhite",
      marginBottom: getsSpecialMargin ? ["10px", "20px", "20px"] : "10px",
      maxWidth: ["unset", "152px", "unset"],
    },
    navigation: {
      variant: isHCP ? "navigationBlue" : "navigationWhite",
      marginLeft: isHCP ? "18px" : "24px",
      minWidth: "103px",
      maxWidth: isHCP ? "150px" : "unset",
    },
    mobileNavigation: {
      variant: isHCP ? "navigationWhite" : "navigationBlue",
      marginLeft: 0,
      marginBottom: "18px",
    },
  };

  return (
    <Link
      href={to}
      width="fit-content"
      height="fit-content"
      className={
        // eslint-disable-next-line no-restricted-globals
        location.href === to ? "active" : ""
      }
      {...VARIANT_STYLES[variant]}
    >
      {children}
    </Link>
  );
};

export default NavigationLink;
